import { render, staticRenderFns } from "./JoinLeaveButton.vue?vue&type=template&id=3a031480&"
import script from "./JoinLeaveButton.vue?vue&type=script&lang=js&"
export * from "./JoinLeaveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports